import { Button } from '@mui/material';
import AdminFeeComp from './AdminFeeComp';
import { useEffect, useRef, useState } from 'react';
import AddDealerBonus from './AddDealerBonus';
import ComRateInput from './ComRateInput';
import axios from '../../axios/axios';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { Checkbox, DatePicker, InputNumber } from 'antd';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import LoaderComp from '../../components/LoaderComp';
import CustomPopOver from './CustomPopOver';
import { useContext } from 'react';
import { InterestRateContext } from './index';
import moment from 'moment';
import ChooseBonus from './ChooseBonus';
import BonusCard from '../DealerBonus/BonusCard';
import RadioInput from '../../components/Form/RadioInput';

const EditInterest = (props) => {
  const { product } = props;
  const { refetch } = useContext(InterestRateContext);
  const adminFeeRef = useRef(null);
  const [checkBox, setcheckBox] = useState('');
  const methods = useForm({
    defaultValues: {
      startDate: '',
      endDate: '',
      scheduleDate: '',
      incentive_amount: '',
      adminfees: [
        {
          admin_fee: '',
          minimum_loan_amount: '',
          maximum_loan_amount: '',
        },
      ],
      year_status: {
        year1_status: 0,
        year2_status: 0,
        year3_status: 0,
        year4_status: 0,
        year5_status: 0,
        year6_status: 0,
        year7_status: 0,
        year8_status: 0,
        year9_status: 0,
        year10_status: 0,
      },
      year_fee: {
        year1_fee: '',
        year2_fee: '',
        year3_fee: '',
        year4_fee: '',
        year5_fee: '',
        year6_fee: '',
        year7_fee: '',
        year8_fee: '',
        year9_fee: '',
        year10_fee: '',
      },
    },
  });
  const { register, control, reset } = methods;
  const {
    formState: { errors },
    setValue,
    getValues,
    watch,
  } = methods;
  const [conflictMsg, setConflictMsg] = useState(null);
  const [bonusconflictMsg, setBonusConflictMsg] = useState(null);
  const [bonusPopUp, setBonusPopUp] = useState(false);
  const [selBonus, setSelBonus] = useState(false);
  const [bonusCards, setbonusCards] = useState([]);
  const [scheduleUpdate, setscheduleUpdate] = useState(null);
  const [isLoading, setisLoading] = useState(false);
  const [adderValInp, setAdderValInp] = useState(0.01);
  const [dealComErr, setDealComErr] = useState(false);
  const [hasIncentive, setHasIncentive] = useState(false);
  const [commisionType, setCommisionType] = useState(1);
  const [editForm, setEditForm] = useState({
    form: false,
    id: '',
  });
  const [formData, setFormData] = useState({
    product: '',
    interest: '',
    agentbonuses: [],
    incentive_type: 0,
    commision_type: 1,
  });

  const handleBonusPopUp = (state) => {
    setBonusPopUp(!bonusPopUp);
  };

  const handleselBonus = () => {
    setSelBonus(!selBonus);
  };

  const handleIncentiveType = (e) => {
    setcheckBox(e.target.value);
    const IncentiveType = e.target.value === 'per' ? 1 : 2;
    setFormData({
      ...formData,
      incentive_type: IncentiveType,
    });
  };

  const handleCommisionType = (e) => {
    setCommisionType(e.target.value);
    setFormData({
      ...formData,
      commision_type: e.target.value,
    });
  };

  // console.log("bonusCards", bonusCards)

  const adderValue = (act) => {
    Array.from({ length: 10 }).forEach((_, idx) => {
      if (act === 'inc') {
        let status = getValues(`year_status.year${idx + 1}_status`);
        let prevVal = getValues(`year_fee.year${idx + 1}_fee`);
        if (status) {
          const sumVal = Number(prevVal) + Number(adderValInp);
          setValue(`year_fee.year${idx + 1}_fee`, sumVal);
        }
      }
      if (act === 'dec') {
        let prevVal = getValues(`year_fee.year${idx + 1}_fee`);
        if (prevVal !== undefined) {
          const sumVal = Number(prevVal) - Number(adderValInp);
          setValue(`year_fee.year${idx + 1}_fee`, sumVal > 0 ? sumVal : 0.0);
        }
      }
    });
  };
  const submitData = async (data) => {
    // console.log("DATTTA", data)
    let errCount = 0;
    setConflictMsg(null);
    setBonusConflictMsg(null);
    data.adminfees.forEach((item) => {
      if (parseFloat(item.maximum_loan_amount) <= parseFloat(item.minimum_loan_amount)) {
        setConflictMsg(
          'Loan amount is conflicting, pls create without conflicting loan amount'
        );
        errCount++;
        if (adminFeeRef.current) {
          window.scrollTo({
            top: adminFeeRef.current.offsetTop - 50,
            behavior: 'smooth',
          });
        }
      }
    });
    data.adminfees.sort((a, b) => {
      const min1 = parseFloat(a.minimum_loan_amount);
      const max1 = parseFloat(a.maximum_loan_amount);
      const min2 = parseFloat(b.minimum_loan_amount);
      const max2 = parseFloat(b.maximum_loan_amount);
      if ((min1 <= min2 && max1 >= min2) || (min1 >= min2 && min1 <= max2)) {

        setConflictMsg(
          'Loan amount is conflicting, pls create without conflicting loan amount'
        );
        errCount++;
        if (adminFeeRef.current) {
          window.scrollTo({
            top: adminFeeRef.current.offsetTop - 50,
            behavior: 'smooth',
          });
        }
      }
    });
    formData.agentbonuses.sort((a, b) => {
      const min1 = parseFloat(a.minimum_loan_amount);
      const max1 = parseFloat(a.maximum_loan_amount);
      const min2 = parseFloat(b.minimum_loan_amount);
      const max2 = parseFloat(b.maximum_loan_amount);
      if ((min1 <= min2 && max1 >= min2) || (min1 >= min2 && min1 <= max2)) {
        setBonusConflictMsg(
          'Qualifying amount is conflicting, please select another bonus or create new bonus without conflicting amount'
        );
        errCount++;
      }
    });
    if (!dealComErr && errCount === 0) {
      const postData = {
        product: formData.product,
        interest: formData.interest,
        agentbonuses: formData.agentbonuses,
        adminfees: data.adminfees,
        startDate: dayjs(data.startDate).format('YYYY-MM-DD'),
        endDate: data.endDate ? dayjs(data.endDate).format('YYYY-MM-DD') : '',
        has_incentive: hasIncentive ? 1 : 0,
        incentive_type: formData.incentive_type,
        commision_type: formData.commision_type,
        incentive_amount: hasIncentive
          ? formData.incentive_type === 1
            ? Number(data.incentive_percentage)
            : Number(data.incentive_value)
          : '',
        //incentive_amount: data.incentive_amount ? `${data.incentive_amount}` : '0',
        year1_status:
          data.year_status.year1_status === undefined
            ? 0
            : data.year_status.year1_status,
        year2_status:
          data.year_status.year2_status === undefined
            ? 0
            : data.year_status.year2_status,
        year3_status:
          data.year_status.year3_status === undefined
            ? 0
            : data.year_status.year3_status,
        year4_status:
          data.year_status.year4_status === undefined
            ? 0
            : data.year_status.year4_status,
        year5_status:
          data.year_status.year5_status === undefined
            ? 0
            : data.year_status.year5_status,
        year6_status:
          data.year_status.year6_status === undefined
            ? 0
            : data.year_status.year6_status,
        year7_status:
          data.year_status.year7_status === undefined
            ? 0
            : data.year_status.year7_status,
        year8_status:
          data.year_status.year8_status === undefined
            ? 0
            : data.year_status.year8_status,
        year9_status:
          data.year_status.year9_status === undefined
            ? 0
            : data.year_status.year9_status,
        year10_status:
          data.year_status.year10_status === undefined
            ? 0
            : data.year_status.year10_status,
        year1_fee:
          data.year_fee.year1_fee === ''
            ? '0'
            : String(data.year_fee.year1_fee),
        year2_fee:
          data.year_fee.year2_fee === ''
            ? '0'
            : String(data.year_fee.year2_fee),
        year3_fee:
          data.year_fee.year3_fee === ''
            ? '0'
            : String(data.year_fee.year3_fee),
        year4_fee:
          data.year_fee.year4_fee === ''
            ? '0'
            : String(data.year_fee.year4_fee),
        year5_fee:
          data.year_fee.year5_fee === ''
            ? '0'
            : String(data.year_fee.year5_fee),
        year6_fee:
          data.year_fee.year6_fee === ''
            ? '0'
            : String(data.year_fee.year6_fee),
        year7_fee:
          data.year_fee.year7_fee === ''
            ? '0'
            : String(data.year_fee.year7_fee),
        year8_fee:
          data.year_fee.year8_fee === ''
            ? '0'
            : String(data.year_fee.year8_fee),
        year9_fee:
          data.year_fee.year9_fee === ''
            ? '0'
            : String(data.year_fee.year9_fee),
        year10_fee:
          data.year_fee.year10_fee === ''
            ? '0'
            : String(data.year_fee.year10_fee),
        remarks1: data.remarks1,
        remarks2: data.remarks2,
        remarks3: data.remarks3,
        remarks4: data.remarks4,
      };
      const accessToken = localStorage.getItem('agentModuleToken');
      if (editForm.form) {
        if (props.schedule) {
          let fromData = postData;
          delete fromData.interest;
          delete fromData.product;
          fromData = {
            ...fromData,
            scheduleDate: dayjs(data.scheduleDate).format('YYYY-MM-DD HH:00'),
          };
          let currentData = {
            ...scheduleUpdate,
            schedule: fromData,
          };
          try {
            const resp = await axios.put(
              `/interest/bonus/update/${editForm.id}`,
              currentData,
              {
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                },
              }
            );
            // console.log(resp);
            if (resp?.data?.resp_code === 200) {
              refetch();
              toast.success('Scheduled Successfully');
              props.scheduleSave();
            }
          } catch (err) {
            const ErrMsg =
              err?.response?.data?.errors !== undefined
                ? err?.response?.data?.errors
                : 'Loan Product not updated..!';
            const temp =
              Object.values(ErrMsg) !== undefined &&
                Object.values(ErrMsg)?.length > 0
                ? Object.values(ErrMsg).pop()
                : 'Loan Product not updated..!';
            toast.error(temp);
          }
        } else {
          try {
            const resp = await axios.put(
              `/interest/bonus/update/${editForm.id}`,
              postData,
              {
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                },
              }
            );
            if (resp?.data?.resp_code === 200) {
              refetch();
              toast.success('Updated Successfully');
              props.saveHandle();
            }
          } catch (err) {
            const ErrMsg =
              err?.response?.data?.errors !== undefined
                ? err?.response?.data?.errors
                : 'Loan Product not updated..!';
            const temp =
              Object.values(ErrMsg) !== undefined &&
                Object.values(ErrMsg)?.length > 0
                ? Object.values(ErrMsg).pop()
                : 'Loan Product not updated..!';
            toast.error(temp);
          }
        }
      } else {
        try {
          const resp = await axios.post('/interest/bonus/create', postData, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          });
          if (resp?.data?.resp_code === 200) {
            refetch();
            toast.success('Created Successfully');
            props.saveHandle();
          }
        } catch (err) {
          const ErrMsg =
            err?.response?.data?.errors !== undefined
              ? err?.response?.data?.errors
              : 'Loan Product not updated..!';
          const temp =
            Object.values(ErrMsg) !== undefined &&
              Object.values(ErrMsg)?.length > 0
              ? Object.values(ErrMsg).pop()
              : 'Loan Product not updated..!';
          toast.error(temp);
        }
      }
    }
  };
  const handleSubmitClick = () => {
    setDealComErr(false);
    let defData = getValues().year_status;
    console.log("defData======",defData)
    const hasCommision = Object.keys(defData).some((key) => {
      if (key.endsWith('_status')) {
        return defData[key] === 1;
      }
      return false;
    });
    if (!hasCommision) {
      setDealComErr(true);
    }
  };
  const getSelectBonus = (state) => {
    setFormData({
      ...formData,
      agentbonuses: state,
    });
    setbonusCards(state);
  };
  useEffect(() => {
    setisLoading(true);
    if (product) {
      // console.log(product);
      setFormData({
        ...formData,
        product: product.product,
        interest: product.id,
      });
      if (props.schedule) {
       // console.log("if part============")
        setEditForm({ ...editForm, form: true, id: product.agentbonusinfo.id });
        let bonusInfo = product.agentbonusinfo;
        delete bonusInfo.id;
        delete bonusInfo.agent;
        delete bonusInfo.created_at;
        delete bonusInfo.updated_at;
        let bonusCardArr = [];
        bonusInfo.agentbonuses.forEach((item, idx) => {
          if (item?.bonusinfo) {
            bonusCardArr.push(item.bonusinfo);
          }
        });
        bonusInfo.agentbonuses = bonusCardArr;
        setscheduleUpdate(bonusInfo);
        if (bonusInfo.schedule) {
          setEditForm({
            ...editForm,
            form: true,
            id: bonusInfo.schedule.bonus,
          });
          let data = bonusInfo.schedule;
          if (data.adminfees) {
            reset(
              {
                adminfees: data.adminfees,
              },
              {
                errors: true,
                dirtyFields: true,
              }
            );
          }
          setValue(`remarks1`, data.remarks1);
          setValue(`remarks2`, data.remarks2);
          setValue(`remarks3`, data.remarks3);
          setValue(`remarks4`, data.remarks4);
          setValue(
            `incentive_amount`,
            data.has_incentive ? data.incentive_amount : ''
          );
          //setValue(`incentive_type`, data.incentive_type);
          setValue(
            `incentive_percentage`,
            data.incentive_type === 1
              ? data.incentive_amount
              : data.incentive_amount
          );
          setValue(
            `incentive_value`,
            data.incentive_type === 2
              ? data.incentive_amount
              : data.incentive_amount
          );
          setcheckBox(data.incentive_type === 1 ? 'per' : 'dol');
          setHasIncentive(data.has_incentive);
          setValue('startDate', dayjs(data.startDate));
          setValue('endDate', data.endDate ? dayjs(data.endDate) : '');
          setValue('scheduleDate', dayjs(data.scheduleDate));
          Array.from({ length: 10 }).forEach((_, idx) => {
            setValue(`year_fee.year${idx + 1}_fee`, data[`year${idx + 1}_fee`]);
            setValue(
              `year_status.year${idx + 1}_status`,
              data[`year${idx + 1}_status`]
            );
          });
          data.adminfees.forEach((item, idx) => {
            setValue(`adminfees[${idx}].admin_fee`, item.admin_fee);
            setValue(
              `adminfees[${idx}].minimum_loan_amount`,
              item.minimum_loan_amount
            );
            setValue(
              `adminfees[${idx}].maximum_loan_amount`,
              item.maximum_loan_amount
            );
          });
          let bonusInfoArr = [];
          data.agentbonuses.forEach((item, idx) => {
            if (item?.bonusinfo) {
              bonusInfoArr.push(item.bonusinfo);
            }
          });
          setbonusCards(bonusInfoArr);
          setFormData({
            ...formData,
            agentbonuses: bonusInfoArr,
            incentive_type: data.incentive_type,
          });
        }
      } else {
       // console.log("else part===========");

        if (product.agentbonusinfo) {
         // console.log("product part===========");
          let data = product.agentbonusinfo;
          //console.log("data=====", product)
          //console.log('ADMIN FEE', product.agentbonusinfo, data?.adminfees);

          setEditForm({ ...editForm, form: true, id: data.id });
          if (data.adminfees) {
            reset(
              {
                adminfees:
                  data.adminfees?.length > 0
                    ? data?.adminfees
                    : [
                      {
                        admin_fee: '',
                        minimum_loan_amount: '',
                        maximum_loan_amount: '',
                      },
                    ],
              },
              {
                errors: true,
                dirtyFields: true,
              }
            );
          }
          setValue(`remarks1`, data.remarks1);
          setValue(`remarks2`, data.remarks2);
          setValue(`remarks3`, data.remarks3);
          setValue(`remarks4`, data.remarks4);
          setValue(
            `incentive_amount`,
            data.has_incentive ? data.incentive_amount : ''
          );
          setValue(`incentive_type`, data.incentive_type);
          setcheckBox(data.incentive_type === 1 ? 'per' : 'dol');
          setValue(
            `incentive_percentage`,
            data.incentive_type === 1 ? data.incentive_amount : ''
          );
          setValue(
            `incentive_value`,
            data.incentive_type === 2 ? data.incentive_amount : ''
          );
          setHasIncentive(data.has_incentive);
          setValue('startDate', dayjs(data.startDate));
          setValue('endDate', data.endDate ? dayjs(data.endDate) : '');
          Array.from({ length: 10 }).forEach((_, idx) => {
            if (data[`year${idx + 1}_status`]) {
              setValue(
                `year_fee.year${idx + 1}_fee`,
                data[`year${idx + 1}_fee`]
              );
            } else {
              setValue(`year_fee.year${idx + 1}_fee`, '');
            }
            setValue(
              `year_status.year${idx + 1}_status`,
              data[`year${idx + 1}_status`]
            );
          });
          data.adminfees.forEach((item, idx) => {
            setValue(`adminfees[${idx}].admin_fee`, item.admin_fee);
            setValue(
              `adminfees[${idx}].minimum_loan_amount`,
              item.minimum_loan_amount
            );
            setValue(
              `adminfees[${idx}].maximum_loan_amount`,
              item.maximum_loan_amount
            );
          });
          let bonusInfo = [];
          data.agentbonuses.forEach((item, idx) => {
            if (item?.bonusinfo) {
              bonusInfo.push(item.bonusinfo);
            }
          });
          setbonusCards(bonusInfo);
          setCommisionType(data.commision_type);
          setFormData({
            ...formData,
            product: product.product,
            interest: product.id,
            agentbonuses: bonusInfo,
            incentive_type: data.incentive_type,
            commision_type: data.commision_type,
          });
        }
      }
      setisLoading(false);
    }
  }, []);

  //console.log('COMMISIONTYPE', commisionType);
  return (
    <>
      {isLoading ? (
        <LoaderComp />
      ) : (
        <div className='p-[24px_30px_24px_30px] singleLoanTab'>
          {bonusPopUp && <AddDealerBonus closeBonusPopUp={handleBonusPopUp} />}
          <ChooseBonus
            selBonus={selBonus}
            closeBonusPopUp={handleselBonus}
            bonusCards={bonusCards}
            getSelectBonus={getSelectBonus}
          />
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(submitData)} noValidate>
              <div className='flex flex-wrap items-center mt-[25px] gap-[0px_10px] cus_date_pick mb-[27px]'>
                <label className='flex flex-wrap items-center w-full mb-[10px] font-[700] text-[13px] text-[#27272B]'>
                  Publish Date
                  <CustomPopOver For='publish' />
                  {(errors?.startDate || errors?.endDate) && (
                    <p className='text-[red] text-[13px] font-[500] ml-[10px] mb-[0] max-[500px]:w-full max-[500px]:ml-0 max-[500px]:my-[7px]'>
                      *Date Range is Mandatory Field
                    </p>
                  )}
                </label>
                <div>
                  <Controller
                    control={control}
                    name='startDate'
                    rules={{
                      required: true,
                    }}
                    render={({ field, fieldState }) => {
                      return (
                        <DatePicker
                          placeholder='DD-MM-YYYY'
                          format='DD-MM-YYYY'
                          name={field.name}
                          ref={field.ref}
                          className='py-[8px]'
                          value={field.value ? dayjs(field.value) : null}
                          disabledDate={(current) => {
                            return moment().add(-1, 'days') >= current;
                          }}
                          onChange={(date) => {
                            field.onChange(date ? date.valueOf() : null);
                            setValue('endDate', '');
                          }}
                        />
                      );
                    }}
                  />
                </div>
                <span className='mx-[10px] max-[500px]:w-full max-[500px]:my-[10px]'>
                  To
                </span>
                {/* {console.log('STARTDATE', watch('startDate'))} */}
                <div className=''>
                  <Controller
                    control={control}
                    name='endDate'
                    render={({ field, fieldState }) => {
                      return (
                        <DatePicker
                          placeholder='DD-MM-YYYY'
                          format='DD-MM-YYYY'
                          name={field.name}
                          ref={field.ref}
                          className='py-[8px]' // disabledDate={(current) => {
                          //   return moment(`${watch('startDate')}`).add(-1, 'days') >= current;
                          // }}
                          disabledDate={(d) =>
                            d.isBefore(dayjs(watch('startDate')))
                          }
                          value={field.value ? dayjs(field.value) : null}
                          onChange={(date) => {
                            field.onChange(date ? date.valueOf() : null);
                          }}
                        />
                      );
                    }}
                  />
                </div>
              </div>
              {props.schedule && (
                <div className='mb-[27px]'>
                  <label className='flex flex-wrap items-center w-full mb-[10px] text-[13px] text-[#27272B] font-[700]'>
                    Schedule Date
                    <CustomPopOver For='schedule' />
                  </label>
                  <div className=''>
                    <Controller
                      control={control}
                      name='scheduleDate'
                      rules={{
                        required: true,
                      }}
                      render={({ field, fieldState }) => {
                        return (
                          <DatePicker
                            showTime
                            placeholder='DD-MM-YYYY HH:MM'
                            format='DD-MM-YYYY HH:mm'
                            name={field.name}
                            ref={field.ref}
                            className='py-[8px]'
                            value={
                              field.value ? dayjs(field.value).minute(0) : null
                            }
                            onChange={(date) => {
                              field.onChange(date ? date.valueOf() : null);
                            }}
                            onOk={(date) => {
                              field.onChange(date ? date.valueOf() : null);
                            }}
                            minuteStep={60}
                            disabledDate={(current) => {
                              return moment().add(-1, 'days') >= current;
                            }}
                          />
                        );
                      }}
                    />
                  </div>
                </div>
              )}
              <div className='voucher-quantity-block mb-4'>
                <label className='flex flex-wrap items-center w-full mb-[15px] font-[700] text-[13px] text-[#27272B]'>
                  Loan Commission Type
                </label>
                <div className='voucher-quantity-list'>
                  <RadioInput
                    name='options'
                    value='1'
                    label='Pro-rate Commission'
                    className='!mb-0'
                    checked={commisionType == 1}
                    onChange={(val) => handleCommisionType(val)}
                  /> 
                    <RadioInput
                      name='options'
                      value='2'
                      label='Full Commission'
                      className='!mb-0'
                      checked={commisionType == 2}
                      onChange={(val) => handleCommisionType(val)}
                    />  
                </div>
              </div>
              <div className='mb-[27px]'>
                <label className='flex flex-wrap items-center text-[#27272B] font-[700] text-[13px]'>
                  Dealer Commission Rates
                  {(errors?.year_fee || dealComErr) && (
                    <p className='text-[red] text-[13px] font-[500] mb-[0] text-[red] ml-[10px] max-[500px]:w-full max-[500px]:ml-0 max-[500px]:my-[7px]'>
                      *Mandatory Field
                    </p>
                  )}
                </label>
                <div className='flex mt-[16px] gap-[8px]'>
                  <div className='stick_header w-[182px] flex-shrink-0'>
                    <p className='text-[13px] text-[#495159] mb-[15px]'>
                      Tenor (Years)
                    </p>
                    <p className='text-[13px] text-[#495159] mb-[20px]'>
                      Availability
                    </p>
                    <p className='text-[13px] text-[#495159] mb-[0] flex items-center'>
                      Commission
                      <span className='flex items-center justify-between bg-[#679FFF] rounded-[4px] border border-[#0560FB] p-[8.2px_6px] text-white text-[12px] ml-[11px]'>
                        <span className='cursor-pointer flex-shrink-0'>
                          <img
                            src='/images/fi_minus-circle.svg'
                            alt='arrow'
                            onClick={() => adderValue('dec')}
                          />
                        </span>
                        {/* {console.log(
                          'COMMISSIONVALUE',
                          adderValInp,
                          typeof adderValInp
                        )} */}
                        <InputNumber
                          type='number'
                          min={0}
                          placeholder='0.01'
                          precision={2}
                          step='0.01'
                          className='plainInput2'
                          value={adderValInp}
                          onChange={(val) => setAdderValInp(val)}
                        />
                        <span className='cursor-pointer flex-shrink-0'>
                          <img
                            src='/images/fi_plus-circle.svg'
                            alt='arrow'
                            onClick={() => adderValue('inc')}
                          />
                        </span>
                      </span>
                    </p>
                  </div>
                  <div className='flex scBarHidden w-[950px] overflow-x-scroll gap-[10px]'>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((it) => {
                      return <ComRateInput key={it} num={it} />;
                    })}
                  </div>
                </div>
              </div>

              <div className='mb-[27px] admin_fee_sec' ref={adminFeeRef}>
                <label className='flex flex-wrap items-center text-[#27272B] font-[700] text-[13px]'>
                  Admin Fee
                  {errors.adminfees && (
                    <p className='text-[red] text-[13px] font-[500] mb-[0] text-[red] ml-[10px] max-[500px]:w-full max-[500px]:ml-0 max-[500px]:my-[7px]'>
                      *Mandatory Field
                    </p>
                  )}
                  {conflictMsg && (
                    <p className='text-[red] text-[13px] font-[500] mb-[0] text-[red] ml-[10px] max-[500px]:w-full max-[500px]:ml-0 max-[500px]:my-[7px]'>
                      {conflictMsg}
                    </p>
                  )}
                </label>
                <AdminFeeComp />
              </div>
              {/* <div className='mb-[27px]'>
                <label className='flex flex-wrap items-center text-[#27272B] font-[700] text-[13px]'>
                  Incentive{' '}
                  <Checkbox
                    className='ml-[10px]'
                    checked={hasIncentive}
                    onChange={() => setHasIncentive(!hasIncentive)}
                  />
                </label>
                <div className='flex flex-wrap items-center gap-[10px] mt-[16px]'>
                  <div>
                    <label className='block mb-[6px] text-[13px] text-[#495159] font-[500] pl-[27px]'>
                      Percentage
                    </label>
                    <div className='flex items-center mr-[15px]'>
                      <input
                        type='radio'
                        className='scale-[1.5] mr-[15px] cursor-pointer'
                        value='per'
                        checked={checkBox === 'per'}
                        onChange={handleIncentiveType}
                      />
                      <Controller
                        control={control}
                        name='incentive_percentage'
                        rules={{
                          required:
                            formData.incentive_type === 1 ? true : false,
                        }}
                        render={({ field, fieldState }) => {
                          return (
                            <InputNumber
                              type='number'
                              min={0}
                              status={fieldState.error ? 'error' : null}
                              prefix='%'
                              name={field.name}
                              ref={field.ref}
                              value={field.value}
                              disabled={
                                formData.incentive_type !== 1
                                  ? true
                                  : false || hasIncentive
                                    ? false
                                    : true
                              }
                              placeholder='0'
                              style={{ width: 160 }}
                              precision={2}
                              step='0.01'
                              className='cusAdmInputNumber2 percentage arrHid'
                              onChange={(val) => field.onChange(val)}
                            />
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <label className='block mb-[6px] text-[13px] text-[#495159] font-[500] pl-[42px] max-[432px]:pl-[30px]'>
                      Flat Rate
                    </label>
                    <div className='flex items-center'>
                      <input
                        type='radio'
                        className='scale-[1.5] mr-[15px] cursor-pointer'
                        value='dol'
                        checked={checkBox === 'dol'}
                        onChange={handleIncentiveType}
                      />
                      <Controller
                        control={control}
                        name='incentive_value'
                        rules={{
                          required:
                            formData.incentive_type === 2 ? true : false,
                        }}
                        render={({ field, fieldState }) => {
                          return (
                            <InputNumber
                              type='number'
                              min={0}
                              status={fieldState.error ? 'error' : null}
                              prefix='$'
                              value={field.value}
                              ref={field.ref}
                              name={field.name}
                              disabled={
                                formData.incentive_type !== 2
                                  ? true
                                  : false || hasIncentive
                                    ? false
                                    : true
                              }
                              placeholder='000.00'
                              style={{ width: 160 }}
                              precision={2}
                              step='0.01'
                              className='cusAdmInputNumber2 arrHid'
                              onChange={(val) => field.onChange(val)}
                            />
                          );
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div> */}
              <div className='mb-[27px]'>
                <label className='text-[#27272B] font-[700] text-[13px] mb-[9px] inline-block'>
                  Remarks
                </label>
                <div className='mb-[10px]'>
                  <input
                    type='text'
                    placeholder='Remarks 1'
                    className='remarks'
                    name='remarks1'
                    {...register('remarks1')}
                  />
                </div>
                <div className='mb-[10px]'>
                  <input
                    type='text'
                    placeholder='Remarks 2'
                    className='remarks'
                    name='remarks2'
                    {...register('remarks2')}
                  />
                </div>
                <div className='mb-[10px]'>
                  <input
                    type='text'
                    placeholder='Remarks 3'
                    className='remarks'
                    name='remarks3'
                    {...register('remarks3')}
                  />
                </div>
                <div>
                  <input
                    type='text'
                    placeholder='Remarks 4'
                    className='remarks'
                    name='remarks4'
                    {...register('remarks4')}
                  />
                </div>
              </div>
              {/* <div className='mb-[30px]'>
                <label className='flex flex-wrap items-center text-[#27272B] font-[700] text-[13px]'>
                  <span className='mr-[10px]'>Dealer Bonus</span>
                  {bonusconflictMsg && (
                    <p className='text-[red] text-[13px] font-[500] mb-[0] text-[red] max-[500px]:w-full max-[500px]:my-[7px]'>
                      {bonusconflictMsg}
                    </p>
                  )}
                </label>
                <div className='mt-[10px]'>
                  {bonusCards.length > 0
                    ? bonusCards.map((item) => {
                      return (
                        <div key={item.id} className='mb-[15px]'>
                          <BonusCard bonus={item} />
                        </div>
                      );
                    })
                    : null}
                  <div className='mt-[20px]'>
                    <Button
                      type='button'
                      className='sav_btn sel_bns flex-shrink-0'
                      onClick={() => setSelBonus(!selBonus)}
                    >
                      Select Bonus
                    </Button>
                    <Button
                      type='button'
                      className='sav_btn ad_bns flex-shrink-0'
                      onClick={handleBonusPopUp}
                    >
                      Add Bonus
                    </Button>
                  </div>
                </div>
              </div> */}
              <div>
                <Button
                  type='submit'
                  className='sav_btn'
                  onClick={handleSubmitClick}
                >
                  Save Changes
                </Button>
                {props.schedule ? (
                  <Button
                    type='button'
                    className='can_btn'
                    onClick={() =>
                      !product.agentbonusinfo.schedule
                        ? props.fallBack()
                        : props.scheduleSave()
                    }
                  >
                    Cancel
                  </Button>
                ) : (
                  <Button
                    type='button'
                    className='can_btn'
                    disabled={!product.agentbonusinfo}
                    onClick={() => props.saveHandle()}
                  >
                    Cancel
                  </Button>
                )}
              </div>
            </form>
          </FormProvider>
        </div>
      )}
    </>
  );
};

export default EditInterest;
